import React from 'react'
import { Link } from 'gatsby'
import Icon from './Icon'

const HelpHomeLink = ({ variant }) => {
  return (
    <Link to="/" className="flex items-center mb-8 cursor-pointer">
      <div className="flex items-center justify-center rounded-full h-8 w-8 mr-4 bg-white text-secondary">
        <Icon icon="backArrow" className="h-5 w-5 fill-current" />
      </div>
      <span
        className={`pt-1 text-sm font-semibold ${
          variant === 'light' ? 'text-white' : ''
        }`}
      >
        Help Home
      </span>
    </Link>
  )
}

export default HelpHomeLink
